/**
 * SafeIntersections header slots consumed by the shared shell via
 * `safeintersectionsConfig.header`.
 *
 * No SafeIntersections methodology PDFs have been published yet, so Method
 * and Playbook are placeholders pointing at the Abley site — swap in real
 * URLs when the documents exist. Help opens the in-app support form.
 */

import type { HeaderItem } from '#lib/components/Header.svelte';
import { gotoView } from '#lib/navigation.js';

const PLACEHOLDER_LINK = 'https://abley.com/en-us/';

export const dashboard: HeaderItem = {
	label: 'Dashboard',
	action: () => void gotoView('safeintersections')
};

/**
 * Method placeholder — static link, no per-version PDF menu yet (unlike
 * SafeCurves). Keeps the `(system)` builder signature the shared shell expects.
 */
export function method(): HeaderItem {
	return { label: 'Method', href: PLACEHOLDER_LINK };
}
